(function() {
	const sections = document.querySelectorAll('.related-posts');
	const isVisible = Helpers.inViewport([...sections]);

	Helpers.postponeExecution(() => {
		Promise.all([
			Helpers.loadScript(assets.splide.js),
			Helpers.loadStyle(assets.splide.css),
		]).then(() => {
			document.querySelectorAll('.related-posts-slider').forEach(element => {
				new Splide(element, {
					type: 'slide',
					perPage: 3,
					perMove: 1,
					pagination: false,
					arrows: false,
					gap: 56,
					breakpoints: {
						991: {
							perPage: 2,
							gap: 32,
						},
						768: {
							perPage: 1,
							gap: 16,
							padding: {
								left: 32,
								right: 32
							}
						}
					}
				}).mount();
			});
		});
	}, isVisible);

	function copyToClipboard(text) {
		const textarea = document.createElement('textarea');
		textarea.value = text;

		document.body.appendChild(textarea);

		textarea.select();
		textarea.setSelectionRange(0, 99999);

		document.execCommand('copy');

		document.body.removeChild(textarea);

		alert("Copied to clipboard");
	}

	const shareButtons = document.querySelectorAll('.share__link--copy');

	shareButtons.forEach(button => {
		button.addEventListener('click', ev => {
			ev.preventDefault();
			const text = button.getAttribute('href');
			copyToClipboard(text);
		});
	});
})();
